<template>
  <div class="view mybooking">

    <!-- TODO Jamie - Show confirmation number in the brackets -->
    <h1>{{ $t('my-booking.label') }} (#{{ bookingId }})</h1>

    <div class="another-booking">
      <router-link :to="{name: 'find-mybooking'}">{{ $t('my-booking.another') }}</router-link>
    </div>

    <order-summary :cart="cart" :editable="false" />
  </div>
</template>

<script>
import OrderSummary from '@/components/OrderSummary';
import Cart from '@/models/Cart';

export default {
  data() {
    return {
      bookingId: 31044,
      cart: new Cart()
    }
  },

  components: {
    OrderSummary
  },

  created() {
    Cart.loadBooking(this.bookingId).then(data => {
      this.cart = Cart.query().with('items').where('bookingId', this.bookingId).first();
      console.log(this.cart);
    });
  }
}
</script>

<style lang="scss">
.view.mybooking {
  .another-booking {
    text-align: right;
    margin-bottom: 8px;
  }
}
</style>
